<template>
  <div class="artist-details">
    <div class="topImg">
      <img :src="detailsList.picture" class="actorImg">
      <div class="actor-name">
        <p>{{detailsList.name}}</p>
      </div>
    </div>
    <div class="actor-detail">
      <div class="detail-content">{{detailsList.detailed}}</div>
    </div>
    <div class="actor-info normal">
      <div class="top">
        <span class="first">基本信息</span>
      </div>
      <div class="info-list">
        <div class="info-p"><span class="info-title">中文名</span>
          <div class="info-value"><span>{{detailsList.name}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">英文名</span>
          <div class="info-value"><span>{{detailsList.english_name}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">名族</span>
          <div class="info-value"><span>{{detailsList.nation}}</span></div>
        </div>
        <div class="info-p" v-show="this.detailsList.constellation"><span class="info-title">星座</span>
          <div class="info-value"><span>{{detailsList.constellation}}</span></div>
        </div>
        <div class="info-p" v-show="this.detailsList.blood"><span class="info-title">血型</span>
          <div class="info-value"><span>{{detailsList.blood}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">身高</span>
          <div class="info-value"><span>{{detailsList.stature}}cm</span></div>
        </div>
        <div class="info-p"><span class="info-title">体重</span>
          <div class="info-value"><span>{{detailsList.weight}}</span></div>
        </div>
        <div class="info-p" v-show="this.detailsList.place"><span class="info-title">出生地</span>
          <div class="info-value"><span>{{detailsList.place}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">职业</span>
          <div class="info-value"><span>{{detailsList.vocation}}</span></div>
        </div>
        <div class="info-p" v-show="this.detailsList.school"><span class="info-title">毕业院校</span>
          <div class="info-value"><span>{{detailsList.school}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">特长</span>
          <div class="info-value"><span v-for="item in detailsList.perf_keyword" v-if="item.state===1" :key="item.id">{{item.tag}},</span>
          </div>
        </div>
      </div>
      <div class="actor-video-wrapper">
        <video v-show="this.detailsList.video" id="casting" :src="detailsList.video" controls width="100%" height="100%"
               poster="../assets/video-cover.jpg"
               class="actor-video"></video>
      </div>
    </div>
    <div class="actor-ph normal">
      <div class="top">
        <span class="first">演员展示</span>
      </div>
      <div class="actor-showImg">
        <!--<viewer :options="options" :images="aPhNumList">-->
        <swiper :options="swiperOption" style="width: 100%;overflow: hidden;">
          <swiper-slide v-for="(img, index) in aPhNumList" :key="index" style="width: 2rem;">
            <img  :src="img.image_url" v-gallery:groupName alt="" style="width: 2.3rem;height: 3.44rem;">
          </swiper-slide>
        </swiper>
        <!--</viewer>-->

      </div>

    </div>
    <div class="exp normal" v-show="this.detailsList.film_works">
      <div class="top">
        <span class="first">电影作品</span>
      </div>
      <div class="m-item">
        <div class="items-detail" v-html="this.detailsList.film_works"></div>
      </div>
      <div v-if="!this.detailsList.film_works" class="null-wrapper">
        <p class="null-info">--暂无--</p>
      </div>
    </div>
    <div class="exp normal" v-show="this.detailsList.tv_works">
      <div class="top">
        <span class="first">电视剧作品</span>
      </div>
      <div class="tv-item">
        <div class="items-detail" v-html="this.detailsList.tv_works"></div>
      </div>
      <div v-if="!this.detailsList.tv_works" class="null-wrapper">
        <p class="null-info">--暂无--</p>
      </div>
    </div>
    <div class="exp normal" v-show="this.detailsList.advertising_works">
      <div class="top">
        <span class="first">广告作品</span>
      </div>
      <div class="adv-item">
        <div class="items-detail" v-html="this.detailsList.advertising_works"></div>

      </div>
      <div v-if="!this.detailsList.advertising_works" class="null-wrapper">
        <p class="null-info">--暂无--</p>
      </div>
    </div>
    <div class="actor-news normal" v-show="newShow">
      <div class="top">
        <span class="first">新闻报道</span>
      </div>
      <div class="news-content">
        <ul>
          <li class="news-wrapper" v-for="item in detailsList.essay" :key="item.id">
            <router-link :to="{
              name:'Hot',
              params:{
                id:item.id
              }
            }">
              <div class="news-body">
                <div class="new-img-wrapper">
                  <img :src="item.picture" style="width: 2.1rem;height: 1.6rem">
                </div>
                <div class="new-text">
                  <p class="news-title">{{item.title}}</p>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div v-if="isNull" class="null-wrapper">
        <p class="null-info">--暂无--</p>
      </div>
    </div>

  </div>

</template>

<script>
  import {swiper, swiperSlide} from 'vue-awesome-swiper'

  export default {
    name: "Actor",
    data() {
      return {
        aPhNumList: '',
        defaultImg: 'http://yopoo.oss-cn-beijing.aliyuncs.com/miss2.jpg',
        detailsList: [],
        expList: [],
        isNull: false,
        timerIsNull: false,
        newShow: true,
        options: {
          toolbar: false,
          title: false,
        },
        swiperOption: {
          loop: true,
          slidesPerView: 3,
          spaceBetween: 48,
          freeMode: true,
        }
      }
    },
    metaInfo() {
      return {
        title: this.detailsList.name?`${this.detailsList.name} 艺人百科—打造影视行业优秀的资源聚合服务平台`:'',
        meta: [{
          name: 'keywords',
          content: ''
        },
          {
            name: 'description',
            content: this.detailsList.detailed || ''
          }]
      }
    },
    methods: {
      viedoNull() {
        $('#casting').attr('poster', 'http://img.yopoo.cn/spds_img.png');
      },
      rmImg(){
        let $p = $('.c:not(:first-child)')
        $p.remove()
      },
       async getDetails() {
        let detailsApi = `https://api.yopoo.cn/api/v1/actor?id=${this.$route.params.id}`
        await this.$http.get(detailsApi).then(res => {
          this.detailsList =  res.data
          this.aPhNumList = this.detailsList.perf_picture
          if (!this.detailsList.video) {
            this.viedoNull()
          }
          if (res.data.timer.length === 0) {
            this.timerIsNull = true
          }
          if (res.data.essay.length == 0) {
            this.isNull = true
            this.newShow = false
          }
        }, err => {
          console.log(err)
        })
      },
      findNumber(index) {
        const aPhNumList = this.detailsList.perf_picture
        let ImgUrl = ''
        if (aPhNumList !== undefined) {
          for (let i = 0; i < aPhNumList.length; i++) {
            if (aPhNumList[i].number === index) {
              ImgUrl = aPhNumList[i].image_url
            }
          }
          if (ImgUrl === '') {
            ImgUrl = this.defaultImg
          }
          return ImgUrl

        }

      }
    },
    mounted() {
      this.getDetails()
      this.rmImg()
    }
  }
</script>

<style scoped>
  .a{
    display: none;
  }
  .a:nth-child(1){
    display: block;
  }
  .items-detail {
    font-size: .3rem;
    line-height: 1.5;
    margin: .23rem;
  }

  .null-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: .2rem;
  }

  .null-info {
    font-size: .3rem;
    font-weight: lighter;
  }

  .info-list {
    padding-bottom: .5rem;
  }

  .actor-ph {
    display: flex;
    flex-direction: column;

  }

  .normal {
    background: #fff;
    margin-top: .20rem;

  }

  .topImg {
    position: relative;
    /*height: 7.50rem;*/
  }

  .actorImg {
    width: 100%;
    height: auto;
  }

  .actor-name {
    position: absolute;
    height: 10%;
    top: 90%;
    left: 0;
    right: 0;
    bottom: 0;
    color: #fff;
    background: rgba(0, 0, 0, .5);
  }

  .actor-name > p {
    font-size: .34rem; /*rem*/
    font-weight: 400;
    padding-top: .3rem;
    padding-left: .23rem;
  }

  .actor-detail {
    background: #fff;
    font-size: .16rem; /*rem*/
    font-weight: 400;
    display: flex;
    justify-content: center;
  }

  .detail-content {
    font-size: .28rem; /*rem*/
    padding-top: .40rem;
    padding-left: .23rem;
    padding-right: .23rem;
    padding-bottom: .83rem;
    text-align: left;
    /*width: 702rem;*/
    /*height: 256rem;*/
  }

  .first {
    padding-left: .23rem;
    font-weight: bold;
  }

  .info-p {
    display: flex;
    padding-left: .23rem;
    padding-top: .20rem;
  }

  .info-title {
    white-space: nowrap;
    width: .63rem;
    font-size: .32rem; /*rem*/
    font-weight: normal;
  }

  .info-value {
    font-size: .3rem;
    margin-left: 1.13rem;
    color: #666;

  }

  .actor-video-wrapper {
    display: flex;
    justify-content: center;
    padding-bottom: .1rem;
  }

  .actor-video {
    margin: .20rem .24rem .40rem .24rem;

  }

  .actor-showImg {
    margin: .23rem;

  }

  .showImg-top-wrapper {
    display: flex;
  }

  .showImg-bottom-wrapper {
    display: flex;
  }

  .showImg-top, .showImg-bottom {
    width: 1.8rem;
    height: 2.37rem;
    padding: .05rem;
  }

  .showImg-top:nth-child(odd) {
    height: 1.20rem;
  }

  .showImg-bottom:nth-child(even) {
    height: 1.20rem;
  }

  .showImg-bottom:nth-child(odd) {
    margin-top: -1.16rem;
  }

  .new-img-wrapper {
    width: 2.1rem;
    height: 1.6rem;
  }

  .news-body {
    display: flex;
  }

  .news-title {
    font-size: .26rem; /*rem*/
  }

  .new-text {
    width: 5.36rem;
    height: 1.07rem;
    overflow: hidden;
    padding-left: .11rem;
  }

  .news-content {
    margin: .35rem .23rem;
  }

  .news-wrapper {
    padding-bottom: .20rem;
  }

  .news-info {
    font-size: .28rem; /*rem*/
  }

  .exp-img {
    width: 2.24rem;
    height: 1.26rem;
  }

  .time-content {
    display: flex;
    justify-content: space-between;
    margin: .19rem .23rem;
  }

  .content {
    font-size: .3rem; /*rem*/
    margin: 0 .23rem;
  }

  .time {
    font-size: .3rem; /*rem*/
    font-weight: bold;
    margin: .19rem .23rem;
  }

  .top {
    font-size: .32rem;
    padding-top: .1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/Actor.vue